var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchairSpokeGuards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,6.57c-14.21,0-25.76,11.56-25.76,25.76s11.56,25.76,25.76,25.76,25.76-11.56,25.76-25.76S46.21,6.57,32,6.57Zm0,48.52c-12.55,0-22.76-10.21-22.76-22.76S19.45,9.57,32,9.57s22.76,10.21,22.76,22.76-10.21,22.76-22.76,22.76Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32,14.44c-9.87,0-17.9,8.03-17.9,17.9s8.03,17.9,17.9,17.9,17.9-8.03,17.9-17.9S41.87,14.44,32,14.44Zm0,32.8c-8.21,0-14.9-6.68-14.9-14.9s6.68-14.9,14.9-14.9,14.9,6.68,14.9,14.9-6.68,14.9-14.9,14.9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32,24.72c-4.2,0-7.62,3.42-7.62,7.62s3.42,7.62,7.62,7.62,7.62-3.42,7.62-7.62-3.42-7.62-7.62-7.62Zm0,12.23c-2.54,0-4.62-2.07-4.62-4.62s2.07-4.62,4.62-4.62,4.62,2.07,4.62,4.62-2.07,4.62-4.62,4.62Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairSpokeGuards);
export default __webpack_public_path__ + "static/media/wheelchair_spoke_guards.5b34dfd7.svg";
export { ForwardRef as ReactComponent };